import { makeStyles } from "@material-ui/core"

export const vendorListStyle = makeStyles((theme) => ({
    overviewContainer: {
        padding: '2rem'
    },
    arrowIcon: {
        transform: 'rotate(180deg)',
    },
    vendorName: {
        fontWeight: 'bold',
        fontSize: '1.2rem',
    },
    vendorIcon: {
        paddingRight: theme.spacing(1),
        verticalAlign: 'middle',
    }
}));